import {Component, OnInit} from '@angular/core';
import {BaseActions} from '../base-actions';
import {LanguageService} from '../../services/language/language.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.less']
})
export class ErrorPageComponent extends BaseActions implements OnInit {
  title = 'TV SHOP TIJDELIJK OFFLINE';
  description = 'We zijn momenteel aan de slag om jouw TV Shop nog beter te maken.';

  constructor(private languageService: LanguageService) {
    super();
  }
  ngOnInit(): void {
    if (this.isLanguageFrench()) {
      this.title = 'SHOP TV TEMPORAIREMENT HORS LIGNE';
      this.description = 'Nous travaillons actuellement à l\'amélioration de votre SHOP TV.';
    }
  }

  private isLanguageFrench() {
    return this.languageService.getCurrentLanguage() === 'fr';
  }
}
